module.exports = __webpack_public_path__ + "img/tag-pink.a15d5656.svg";